module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"I\u0027m Feeling Indecisive":"I\u0027m Feeling Indecisive","Search restaurants":"Search restaurants","Oops... No results found.":"Oops... No results found."},"ja":{"I\u0027m Feeling Indecisive":"決められない！","Search restaurants":"店を検索","Oops... No results found.":"あっ！結果が見つかりません。"}}')
  delete Component.options._Ctor
}
